enum SelectDateMode {
  TODAY = "TODAY",
  TOMORROW = "TOMORROW",
  SELECT = "SELECT",
  NA = "NA",
}

export default SelectDateMode;
